/* tslint:disable */
/* eslint-disable */
/**
 * Remaster API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import type { ApiError } from './ApiError'
import { ApiErrorFromJSON, ApiErrorFromJSONTyped, ApiErrorToJSON } from './ApiError'
import type { ObjectDetailUser } from './ObjectDetailUser'
import {
  ObjectDetailUserFromJSON,
  ObjectDetailUserFromJSONTyped,
  ObjectDetailUserToJSON,
} from './ObjectDetailUser'

/**
 *
 * @export
 * @interface EnvelopedObjectObjectDetailUser
 */
export interface EnvelopedObjectObjectDetailUser {
  /**
   *
   * @type {ObjectDetailUser}
   * @memberof EnvelopedObjectObjectDetailUser
   */
  body: ObjectDetailUser
  /**
   *
   * @type {Array<ApiError>}
   * @memberof EnvelopedObjectObjectDetailUser
   */
  errors: Array<ApiError>
}

/**
 * Check if a given object implements the EnvelopedObjectObjectDetailUser interface.
 */
export function instanceOfEnvelopedObjectObjectDetailUser(value: object): boolean {
  let isInstance = true
  isInstance = isInstance && 'body' in value
  isInstance = isInstance && 'errors' in value

  return isInstance
}

export function EnvelopedObjectObjectDetailUserFromJSON(
  json: any,
): EnvelopedObjectObjectDetailUser {
  return EnvelopedObjectObjectDetailUserFromJSONTyped(json, false)
}

export function EnvelopedObjectObjectDetailUserFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): EnvelopedObjectObjectDetailUser {
  if (json === undefined || json === null) {
    return json
  }
  return {
    body: ObjectDetailUserFromJSON(json['body']),
    errors: (json['errors'] as Array<any>).map(ApiErrorFromJSON),
  }
}

export function EnvelopedObjectObjectDetailUserToJSON(
  value?: EnvelopedObjectObjectDetailUser | null,
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    body: ObjectDetailUserToJSON(value.body),
    errors: (value.errors as Array<any>).map(ApiErrorToJSON),
  }
}
